import INFTCardButtons from './INFTCardButtons'
import React from 'react'
import styled from 'styled-components'
import NFTButton from '../../../../newComponents/NFTButton'
import { useActiveWeb3React } from '../../../../../../hooks'
import { ApprovalState } from '../../../../../../hooks/useApproveCallback'
import { ZERO_ADDRESS } from '../../../../../../constants'
import { StakeState } from '../../../../models/INFTStake'

export const NFTCardButtonsWrapped = styled.div`
  width: 100%;
  display: flex;

  .nft-button {
    margin-right: 0.5rem;

    &:last-child {
      margin-right: 0;
    }
  }
`

export default function NFTCardButtons(props: INFTCardButtons) {
  const {
    approve,
    buyNow,
    setSale,
    isSale,
    isWallet,
    tokenName,
    token,
    removeSale,
    approveState,
    owner,
    saleToken,
    transferNFT,
    stakeToggle,
    stakeState,
    isStake
  } = props
  const { account } = useActiveWeb3React()
  function getIsSellerOwner() {
    let result: any = false
    if (isSale && token && token.seller) {
      result = token && account && token.seller.toString().toUpperCase() === account.toString().toUpperCase()
    }
    return result
  }

  const isSellerOwner = getIsSellerOwner()
  const isOwner = account?.toLowerCase() === owner?.toLowerCase()
  const isAvax = saleToken?.toLowerCase() === ZERO_ADDRESS
  const disabledBuyNow = isAvax ? false : approveState !== ApprovalState.APPROVED
  const disabledStakeButton = approveState !== ApprovalState.APPROVED

  function getBuyButtons() {
    return (
      <React.Fragment>
        {!isAvax && approveState !== ApprovalState.APPROVED && (
          <NFTButton onClick={() => (approve ? approve() : undefined)}>Approve</NFTButton>
        )}
        <NFTButton disabled={disabledBuyNow} onClick={() => (buyNow ? buyNow() : undefined)}>Buy Now</NFTButton>
      </React.Fragment>
    )
  }

  function getSaleButtons() {
    return (
      <React.Fragment>
        <NFTButton onClick={() => (setSale ? setSale(tokenName) : undefined)}>Sell</NFTButton>
        <NFTButton onClick={() => (transferNFT ? transferNFT(tokenName) : undefined)}>Transfer</NFTButton>
      </React.Fragment>
    )
  }

  function getRemoveButtons() {
    return <NFTButton onClick={() => (removeSale ? removeSale(tokenName) : undefined)}>Remove Sale</NFTButton>
  }

  function getStakeButtons() {
    return (
      <React.Fragment>
        {approveState !== ApprovalState.APPROVED && (
          <NFTButton
            className={approveState === ApprovalState.PENDING ? 'pending' : ''}
            disabled={approveState === ApprovalState.PENDING}
            onClick={() => (approve ? approve() : undefined)}
          >Approve</NFTButton>
        )}
        <NFTButton
          className={stakeState === StakeState.STAKE_PENDING ? 'pending' : ''}
          disabled={disabledStakeButton}
          onClick={() => (stakeToggle ? stakeToggle() : undefined)}
        >{isStake ? 'Unstake' : 'Stake'}</NFTButton>
      </React.Fragment>
    )
  }

  function getButtons() {
    let result = <React.Fragment />
    if (isSale && !isSellerOwner) {
      result = getBuyButtons()
    } else if (isSale && isSellerOwner) {
      result = getRemoveButtons()
    } else if (!isSale && isWallet && isOwner) {
      result = getSaleButtons()
    } else if (stakeToggle) {
      result = getStakeButtons()
    }

    return result
  }

  return <>{getButtons()}</>
}
